import React from 'react';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';


function renderInputComponent(inputProps) {
    const { classes, inputRef = () => { }, ref, ...other } = inputProps;
    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
            }}
            {...other}
        />
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);
    return (
        <MenuItem
            disableGutters={true}
            syle={{ paddingInlineStart: -20 }}
            selected={isHighlighted} component="div">
            <div>
                {parts.map(part => (
                    <span key={part.text} style={{ fontWeight: part.highlight ? 500 : 400 }}>
                        {part.text}
                    </span>
                ))}
            </div>
        </MenuItem>
    );
}


function getSuggestionValue(matchingSuggestion) {
    return matchingSuggestion.label;
}



class Suggestor extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            value: '',
            matchingSuggestions: []

        }
    }

    getSuggestions = (value) => {
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;
        return inputLength === 0
            ? []
            : this.props.suggestions.filter(suggestion => {
                const keep =
                    count < 5 && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    }

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({ matchingSuggestions: this.getSuggestions(value) })

    };

    handleSuggestionsClearRequested = () => {
        this.setState({ matchingSuggestions: [] })
    };

    handleChange = (event, { newValue, method }) => {
       this.setState({
            value: newValue,
        });
        this.props.setValue(newValue)
        
    };

  
    selected = (_, method) => {
        try{
            this.props.fetch(method.suggestion.key)
        } catch (_) {
            console.log('no fetcher defined for suggestion')
        }

        
    }

    render() {
        const autosuggestProps = {
            suggestions: this.state.matchingSuggestions,
            renderInputComponent,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            onSuggestionSelected: this.selected,
            getSuggestionValue,
            renderSuggestion,
        };
        const classes = this.props
        return (
            <div className={classes.root}>
                <Autosuggest
                    {...autosuggestProps}
                    inputProps={{
                        classes,
                        id: 'react-autosuggest-simple',
                        label: this.props.label,
                        placeholder: this.props.placeholder,
                        value: this.state.value,
                        onChange: this.handleChange,
                        
                    }}
                    theme={{
                        container: classes.container,
                        suggestionsContainerOpen: classes.suggestionsContainerOpen,
                        suggestionsList: classes.suggestionsList,
                        suggestion: classes.suggestion,
                    }}
                    renderSuggestionsContainer={options => (
                        <Paper {...options.containerProps} square>
                            {options.children}
                        </Paper>
                    )}
                />
            </div>

        );
    }
}

export default Suggestor;



// WEBPACK FOOTER //
// ./src/utils/suggest.js